import { useSelector } from "react-redux";
import ContactSettingsDialog from "../../pages/addressbook/panels/ContactSettingsDialog";

const SettingsPopup = ({ open, onClose }) => {
  const authorId = useSelector((state) => state.auth.userId);
  return <ContactSettingsDialog open={open} onClose={onClose} authorId={authorId} />;
};

export default SettingsPopup;
